import React, { useState } from "react";
import { useParams } from 'react-router';
import { useNavigate } from 'react-router-dom';
import TitleUnderlined from "../components/TitleUnderlined";
import Row from "../components/Row";
import Column from "../components/Column";
import Divider from "../components/Divider";
import Utils from "../tools/Utils";
import Button from "../components/Button";
import Breadcrumb from "../components/Breadcrumb";
import Order from "../models/Order";
import { RoutesWeb } from "../tools/RoutesWeb";
require('../style/views/ticketDetails.scss');

const EJC_LEGALES_URL = 'https://ejc.mx/legales/';

const breadCrumbItems = [
    {
        title: 'Eventos',
        route: RoutesWeb.HOME
    },
    {
        title: 'Detalles del evento',
        route: RoutesWeb.DETAILS,
    },
    {
        title: 'Boletos',
        active: true
    },
]

const TicketsDetailView = (props) => {
    const { obj } = useParams();
    const [order, setOrder] = useState(Order.fromJson(JSON.parse(Utils.decodeBase64(obj))));
    const [wasValidated, setWasValidated] = useState(false);
    const navigate = useNavigate();


    const handleData = (e) => {
        let newOrder = order;
        if (e.target.name !== 'main_email') {
            let name = e.target.name.split('_');
            let tmpObj = { ...newOrder.attendees[parseInt(name[1], 10)] };
            if (name[0] === 'phoneNumber') {
                tmpObj.phoneNumber = e.target.value.replace(/\D/g, '').slice(0, 10);
            } else {
                tmpObj[name[0]] = e.target.value;
            }
            if (tmpObj.birthDate) {
                const age = Math.floor((new Date() - new Date(tmpObj.birthDate)) / (365.25 * 24 * 60 * 60 * 1000));
                tmpObj.age = age.toString();
                tmpObj.isMinor = age < 18;
            } else {
                tmpObj.age = null;
                tmpObj.isMinor = false;
            }
            newOrder.attendees[name[1]] = tmpObj;
        } else {
            newOrder.mainEmail = e.target.value;
        }
        setOrder({ ...newOrder });
    }

    const handleSubmit = (e) => {
        if(e.target.checkValidity() === false) {
            e.preventDefault();
            e.stopPropagation();
            Utils.Toast.fire({
                icon: 'error',
                text: 'Faltan campos obligatorios por llenar'
            });
            setWasValidated('was-validated');
        } else {
            e.preventDefault();
            e.stopPropagation();
            navigate(`/pago/${Utils.encodeBase64(JSON.stringify(order))}`);
        }
    } 

    return (
        <div className="pt-5 pb-5" id="ticketDetail">
            <Breadcrumb items={breadCrumbItems} />
            <form onSubmit={handleSubmit} className={`needs-validation ${wasValidated}`} noValidate>
                <TitleUnderlined>Detalles de <span className="embercom_overlined">Boletos</span></TitleUnderlined>
                <p className="mt-2">Por favor, rellene la siguiente información para continuar:</p>
                <Row>
                    <Column className="col-md-6">
                        <div className="form-group">
                            <label htmlFor="exampleInputEmail1" className="semibold"><b>Correo principal de envío de correos</b></label>
                            <input type="email" className="form-control" id="exampleInputEmail1" name="main_email" aria-describedby="emailHelp" required onChange={handleData} />
                        </div>
                    </Column>
                </Row>
                <br />
                <br />
                {/* <br /> */}
                <h4 className="text-uppercase"><b>Información de los visitantes</b></h4>
                <Divider />
                <table className="table border-0">
                    <thead>
                        <tr>
                            <th className="semibold border-0">Boleto</th>
                            <th className="semibold border-0">Nombre</th>
                            <th className="semibold border-0">Teléfono</th>
                            <th className="semibold border-0">Nacimiento</th>
                            <th className="semibold border-0">Sexo</th>
                            {/*
                            Opcionales / ocultos por negocio (reactivar si se vuelven a pedir en UI):
                            <th className="semibold border-0">Correo individual</th>
                            <th className="semibold border-0">Archivo</th>
                            <th className="semibold border-0">Carta menor</th>
                            */}
                        </tr>
                    </thead>
                    <tbody>
                        {order.attendees.map((data, index) => {
                            return(
                            <tr key={index} className="border-0">
                                <td className="border-0"><b>1</b></td>
                                <td className="border-0"><input className="form-control" type="text" name={`fullName_${index}`} onChange={handleData} required /></td>
                                <td className="border-0">
                                    <input
                                        className="form-control"
                                        type="text"
                                        name={`phoneNumber_${index}`}
                                        inputMode="numeric"
                                        autoComplete="tel-national"
                                        pattern="[0-9]{10}"
                                        maxLength={10}
                                        title="10 dígitos, solo números"
                                        value={order.attendees[index]?.phoneNumber ?? ''}
                                        onChange={handleData}
                                        required
                                    />
                                </td>
                                <td className="border-0"><input className="form-control" type="date" name={`birthDate_${index}`} onChange={handleData} required /></td>
                                <td className="border-0">
                                    <select className="form-control" name={`gender_${index}`} onChange={handleData} required>
                                        <option value="">Seleccione</option>
                                        <option value="male">Hombre</option>
                                        <option value="female">Mujer</option>
                                    </select>
                                </td>
                                {/*
                                <td className="border-0"><input className="form-control" type="email" name={`email_${index}`} onChange={handleData} /></td>
                                <td className="border-0"><input className="form-control" type="file" accept=".jpg,.jpeg,.png,.pdf" name={`attachment_${index}`} onChange={handleData} /></td>
                                <td className="border-0"><input className="form-control" type="file" accept=".jpg,.jpeg,.png,.pdf" name={`responsibilityLetter_${index}`} onChange={handleData} /></td>
                                */}
                            </tr>)
                        })}
                    </tbody>
                </table>
                <br />
                <br />
                <Row>
                    <Column className="col-md-10">
                        <h4 className="text-uppercase mb-3"><b>Aceptación de términos legales</b></h4>
                        <p className="mb-3">
                            <a
                                href={EJC_LEGALES_URL}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="d-inline-block"
                            >
                                Documentos legales completos (PDF)
                            </a>
                        </p>
                        <div className="form-check mb-3">
                            <input
                                type="checkbox"
                                className="form-check-input"
                                id="aceptoTerminosLegalesEjc"
                                name="aceptoTerminosLegalesEjc"
                                required
                            />
                            <label className="form-check-label" htmlFor="aceptoTerminosLegalesEjc">
                                Declaro haber leído, comprendido y aceptado en su totalidad el Contrato de Adhesión, Términos, Políticas, Condiciones de Participación y Aviso de Privacidad del Encuentro Juvenil Católico (EJC), por lo que consiento obligarme conforme a los mismos.
                            </label>
                        </div>
                        <div className="form-check">
                            <input
                                type="checkbox"
                                className="form-check-input"
                                id="autorizoUsoImagenEjc"
                                name="autorizoUsoImagenEjc"
                            />
                            <label className="form-check-label" htmlFor="autorizoUsoImagenEjc">
                                Autorizo el uso de mi imagen y voz en los términos establecidos en el Contrato de Adhesión, Términos y Condiciones y Aviso de Privacidad del Encuentro Juvenil Católico (EJC).
                            </label>
                        </div>
                    </Column>
                </Row>
                <br />
                <br />
                <Button>Continuar donativo <img src={require('../assets/arrow_next.png')} alt="arrowNext" /></Button>
            </form>
        </div>
    )
}

export default TicketsDetailView;